module.exports = __webpack_public_path__ + "static/media/torte.8830b122.jpg";